module.exports = "../../app/cells/components/modals/setup_wizard/next_action.erb";